import {mapState} from 'vuex';
import {VSnackbar} from 'vuetify/lib';

const NotifyToast = {
  components: {VSnackbar},
  template: '<v-snackbar :color="notification.color" :timeout="notification.timeout" bottom right ' +
      'v-model="notification.show">{{ notification.message }}</v-snackbar>',
  computed: {
    ...mapState('notify', ['notification'])
  }
};

const NotifyVuex = {
  namespaced: true,
  state: {
    notification: {
      message: '',
      color: 'info',
      timeout: 1000,
      show: false
    }
  },
  mutations: {
    addNotification(state, notification) {
      state.notification.show = false;
      setTimeout(() => {
        notification.show = true;
        state.notification = notification;
      }, 250);
    }
  },
  actions: {
    postNotification({commit}, notification) {
      const n = {};
      n.message = notification.message;
      if (notification.hasOwnProperty('color')) {
        n.color = notification.color;
      } else {
        n.color = 'info';
      }
      if (notification.hasOwnProperty('timeout')) {
        n.timeout = notification.timeout;
      } else {
        n.timeout = 3000;
      }

      commit('addNotification', n);
    },
    showError({dispatch}, message) {
      dispatch('postNotification', {
        message: message,
        color: 'error',
        timeout: 10000,
        show: true
      });
    },
    showSuccess({dispatch}, message) {
      dispatch('postNotification', {
        message: message,
        color: 'success',
        timeout: 2000,
        show: true
      });
    }
  }
};

const Notify = {
  install(Vue, options) {
    if (!options || !options.store) {
      throw new Error('Please initialise plugin with a Vuex store.');
    }

    // inject store
    this.store = options.store;

    // register module with Vuex store
    this.store.registerModule('notify', NotifyVuex);

    // register display component
    Vue.component('notify-toast', NotifyToast);

    // expose functions for use in components
    Vue.prototype.$notify = {
      postNotification: (notification) => {
        return this.store.dispatch('notify/postNotification', notification);
      },
      showError: (message) => {
        return this.store.dispatch('notify/showError', message);
      },
      showSuccess: (message) => {
        return this.store.dispatch('notify/showSuccess', message);
      }
    };
  }
};

export {
  Notify
};
